import { SegmentPartnerRevenueMethod } from '@openx/types/gqlTypes.ts';

export const REVENUE_METHOD_OPTIONS = [
  { value: SegmentPartnerRevenueMethod.PoM, label: 'Percentage of Media' },
  { value: SegmentPartnerRevenueMethod.Cpm, label: 'Fixed CPM' },
];

/** Whether contextual rows carry an OpenX platform fee; off until the API can store one (EXCH-19412). */
export const CONTEXTUAL_PLATFORM_FEE_SUPPORTED: boolean = false;

/**
 * Whether internal admins can edit the OpenX platform fees. Off while the API saves them incorrectly, so admins see
 * them read-only (still with the net fee) and the saved fees are kept. On once both the audience and the contextual
 * fees can be saved (see CONTEXTUAL_PLATFORM_FEE_SUPPORTED). Audience fees: EXCH-19406; contextual fees: EXCH-19578.
 */
export const PLATFORM_SHARE_EDIT_SUPPORTED: boolean = false;

export const NUMBER_FORMATS = {
  CURRENCY: {
    style: 'currency' as const,
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  PERCENTAGE: {
    style: 'percent' as const,
    maximumFractionDigits: 2,
  },
} as const;
